module.exports = __webpack_public_path__ + "static/media/Tosee_Taavon.a59d0978.svg";